export default __webpack_public_path__ + "static/media/Amazon-clone.9539bd65.png";